import { dateUtil } from '@goodfynd/react-web.lib.utils';
import * as yup from 'yup';
import { z } from 'zod';

import strings from '../../../config/strings';
export const emailValidatorZod = z
  .string()
  .email(strings.validations.emailInvalid);

export const emailValidator = yup
  .string()
  .email(strings.validations.emailInvalid);

export const basicInfoValidation = yup.object({
  image: yup.string(),
  organizationName: yup.string(),
  eventName: yup.string().required(),
  description: yup.string().required(),
  rsvpSite: yup.string(),
});

export const organizationInfoValidation = yup.object({
  title: yup.string(),
  firstName: yup.string().required(),
  lastName: yup.string(),
  email: yup.string().email().required(),
  phone: yup.string().required(),
  mobile: yup.string(),
  adminEmails: yup.array().of(yup.string().email()),
});

export const eventDetailsValidation = yup.object({
  numberOfVendors: yup.number().required(),
  vendingFee: yup.number(),
  numberOfGuest: yup.number().required(),
  assignedSeating: yup.boolean(),
  rainOrShine: yup.boolean(),
});

export const eventLocationValidation = yup.object({
  location: yup
    .object({
      city: yup.string(),
      state: yup.string(),
      zip: yup.string(),
      address: yup.string().required(),
      coordinates: yup.string().required(),
    })
    .default(undefined)
    .required(),
  parkingInstructions: yup.string(),
});

export const eventTimesValidation = yup.object({
  dates: yup
    .array(yup.date())

    .default([])
    .min(1, 'Choose at least one date to continue.'),
  start: yup.date().nullable().typeError('Invalid time').required(),
  setup: yup
    .date()
    .nullable()
    .typeError('Invalid time')
    .when('start', (start, yup) =>
      start ? yup.max(start, 'Setup time must be before start time') : yup
    )
    .required(),
  end: yup
    .date()
    .nullable()
    .typeError('Invalid time')

    .when('start', (start, yup) =>
      start
        ? yup.min(
            dateUtil.addMinutes(start, 1),
            'End time must be after start time'
          )
        : yup
    )
    .required(),
});

export const adminValidation = yup.object({
  notify: yup.boolean(),
  orderingFee: yup.number(),
  posFee: yup.number(),
  receiptImage: yup.string(),
  sponsorImage: yup.string(),
  dontRequireSubscription: yup.boolean(),
  subscription: yup.string(),
  updatedBy: yup.string(),
  uploadedBy: yup.string(),
});
